import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PlaygroundHistoryEntry {
  id?: string;
  method: string;
  path: string;
  bodyText: string;
  status: number;
  durationMs: number;
  occurredAt: string;
}

/**
 * Cloud-synced history of past Playground requests (docs/KONZEPT-Developer-Platform.md —
 * tenant-shared and persisted server-side via /api/developer/history, same pattern as
 * CollectionApiService, so history now follows the developer across devices/browsers
 * instead of living only in this one's IndexedDB). Public surface stays Promise-based so
 * existing ".then(...)" call sites in playground.page.ts keep compiling unchanged.
 */
@Injectable({ providedIn: 'root' })
export class PlaygroundHistoryService {
  private readonly base = `${environment.apiUrl}/developer/history`;

  constructor(private http: HttpClient) { }

  async add(entry: Omit<PlaygroundHistoryEntry, 'id'>): Promise<void> {
    await firstValueFrom(this.http.post<PlaygroundHistoryEntry>(this.base, entry));
  }

  list(): Promise<PlaygroundHistoryEntry[]> {
    return firstValueFrom(this.http.get<PlaygroundHistoryEntry[]>(this.base));
  }

  async clear(): Promise<void> {
    await firstValueFrom(this.http.delete<void>(this.base));
  }
}
